import _classCallCheck from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import '@/captcha/slider/slider.less';
import './rotate.less';
import { Dom, CommonCaptcha, down, initConfig, destroyEvent } from '../common/common.js';

/**
 * 滑动验证码
 */

var TYPE = 'ROTATE';
function getTemplate(styleConfig) {
  return "\n<div id=\"tianai-captcha\" class=\"tianai-captcha-slider tianai-captcha-rotate\">\n    <div class=\"slider-tip\">\n        <span id=\"tianai-captcha-slider-move-track-font\" style=\"font-size: ".concat(styleConfig.i18n.rotate_title_size, "\">").concat(styleConfig.i18n.rotate_title, "</span>\n    </div>\n    <div class=\"content\">\n        <div class=\"bg-img-div\">\n            <img id=\"tianai-captcha-slider-bg-img\" src=\"\" alt/>\n            <canvas id=\"tianai-captcha-slider-bg-canvas\"></canvas>\n        </div>\n        <div class=\"rotate-img-div\" id=\"tianai-captcha-slider-img-div\">\n            <img id=\"tianai-captcha-slider-move-img\" src=\"\" alt/>\n        </div>\n         <div class=\"tianai-captcha-tips\" id=\"tianai-captcha-tips\"></div>\n    </div>\n    <div class=\"slider-move\">\n        <div class=\"slider-move-track\">\n            <div id=\"tianai-captcha-slider-move-track-mask\"></div>\n            <div class=\"slider-move-shadow\"></div>\n        </div>\n        <div class=\"slider-move-btn\" id=\"tianai-captcha-slider-move-btn\">\n        </div>\n    </div>\n</div>\n");
}
var Rotate = /*#__PURE__*/function (_CommonCaptcha) {
  function Rotate(boxEl, styleConfig) {
    var _this;
    _classCallCheck(this, Rotate);
    _this = _callSuper(this, Rotate);
    _this.boxEl = boxEl;
    _this.styleConfig = styleConfig;
    _this.type = TYPE;
    _this.currentCaptchaData = {};
    return _this;
  }
  _inherits(Rotate, _CommonCaptcha);
  return _createClass(Rotate, [{
    key: "init",
    value: function init(captchaData, endCallback, loadSuccessCallback) {
      // 重载样式
      this.destroy();
      this.boxEl.append(getTemplate(this.styleConfig));
      this.el = this.boxEl.find('#tianai-captcha');
      this.loadStyle();
      // 按钮绑定事件
      this.el.find('#tianai-captcha-slider-move-btn').mousedown(down.bind(null, this));
      this.el.find('#tianai-captcha-slider-move-btn').touchstart(down.bind(null, this));
      // 绑定全局
      // window.currentCaptcha = this;
      // 载入验证码
      this.loadCaptchaForData(this, captchaData);
      this.endCallback = endCallback;
      if (loadSuccessCallback) {
        // 加载成功
        loadSuccessCallback(this);
      }
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var existsCaptchaEl = this.boxEl.children('#tianai-captcha');
      if (existsCaptchaEl) {
        existsCaptchaEl.remove();
      }
      destroyEvent();
    }
  }, {
    key: "doMove",
    value: function doMove() {
      var moveX = this.currentCaptchaData.moveX;
      this.el.find('#tianai-captcha-slider-move-btn').css('transform', 'translate(' + moveX + 'px, 0px)');
      this.el.find('#tianai-captcha-slider-move-img').css('transform', 'rotate(' + moveX / (this.currentCaptchaData.end / 360) + 'deg)');
      this.el.find('#tianai-captcha-slider-move-track-mask').css('width', moveX + 'px');
    }
  }, {
    key: "loadStyle",
    value: function loadStyle() {
      var sliderImg = '';
      var moveTrackMaskBorderColor = '#00f4ab';
      var moveTrackMaskBgColor = '#a9ffe5';
      var styleConfig = this.styleConfig;
      if (styleConfig) {
        sliderImg = styleConfig.btnUrl;
        moveTrackMaskBgColor = styleConfig.moveTrackMaskBgColor;
        moveTrackMaskBorderColor = styleConfig.moveTrackMaskBorderColor;
      }
      this.el.find('.slider-move .slider-move-btn').css('background-image', 'url(' + sliderImg + ')');
      // this.el.find("#tianai-captcha-slider-move-track-font").text(title);
      this.el.find('#tianai-captcha-slider-move-track-mask').css('border-color', moveTrackMaskBorderColor);
      this.el.find('#tianai-captcha-slider-move-track-mask').css('background-color', moveTrackMaskBgColor);
    }
  }, {
    key: "loadCaptchaForData",
    value: function loadCaptchaForData(that, data) {
      var bgImg = that.el.find('#tianai-captcha-slider-bg-img');
      var sliderImg = that.el.find('#tianai-captcha-slider-move-img');
      bgImg.attr('src', data.captcha.backgroundImage);
      sliderImg.attr('src', data.captcha.templateImage);
      bgImg.on('load', function () {
        that.currentCaptchaData = initConfig(bgImg.width(), bgImg.height(), sliderImg.width(), sliderImg.height(), 300 - 63 + 5);
        that.currentCaptchaData.currentCaptchaId = data.id;
      });
    }
  }]);
}(CommonCaptcha);
export default Rotate;